<template>
    <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            background-color="var(--scheme-color9)"
            text-color="#fff"
            active-text-color="var(--scheme-color1)"
            mode="horizontal"
            :ellipsis="false"
            @select="handleSelect"
    >
        <el-menu-item index="0" class="logo">Soulexe商户平台 - {{merchant.name}}</el-menu-item>
        <div class="flex-grow" />
        <el-sub-menu :index="item.id" v-for="item in menuList" :key="item.id">
            <template #title>
                <span>{{ item.title }}</span>
            </template>
            <el-menu-item :index="subItem.id" v-for="subItem in item.children" :key="subItem.id">
                {{ subItem.title }}
            </el-menu-item>
        </el-sub-menu>
    </el-menu>
</template>

<script>
import Service from "@/util/request";
import ApiConst from "@/util/apiConst";
import router from '@/router'
import Helpers from "@/util/common";

export default {
    name: "HeaderBar",
    components: {},
    data() {
        return {
            activeIndex: 1,
            //用户个人信息
            user: {
                name: ''
            },
            merchant: {
                name: ''
            },
            menuList:[]
        };
    },
    created() {
        this.getAdminInfo();
    },
    methods: {
        getAdminInfo(){
            let _this = this;
            Service.request(ApiConst.AdminInfo, {}, function(data){
                _this.user = data;
                Helpers.setCurrentAdmin(data);
                _this.merchant = data["merchant_info"];
                _this.initMenu();
            });
        },
        initMenu(){
            let _this = this;
            Service.request(ApiConst.menuList, {}, function(data){
                _this.menuList = data.menus;
                let uc = {
                    "id": "user", "title": _this.user.name, "children": [
                        {"id": "logout", "title": "退出登录", "link":"/logout"},
                    ]
                };
                // 账号管理并入个人中心
                for (let i in _this.menuList) {
                    if (_this.menuList[i]["title"] === "账号管理") {
                        uc["children"] = _this.menuList[i]["children"].concat(uc["children"]);
                        _this.menuList.splice(i, 1);
                        break;
                    }
                }
                _this.menuList.push(uc)
            });
        },
        handleSelect(key, keyPath){
            if (key === "0") {
                router.push("/").then();
                return;
            }
            for(let i in this.menuList){
                if (this.menuList[i]["id"] === keyPath[0]) {
                    if (keyPath.length === 1){
                        if ("link" in this.menuList[i]){
                            router.push(this.menuList[i]["link"]).then();
                            return;
                        }
                    }
                    for(let j in this.menuList[i]["children"]){
                        if (this.menuList[i]["children"][j]["id"] === key){
                            if ("link" in this.menuList[i]["children"][j]){
                                if (this.menuList[i]["children"][j]["link"] === "/logout"){
                                    Helpers.clearCurrentAdmin();
                                    location.href = "/nebula_api/admin/logout";
                                } else {
                                    router.push(this.menuList[i]["children"][j]["link"]).then();
                                }
                                return;
                            }
                        }
                    }
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.logo {
  font-weight: bold;
}
.flex-grow {
  flex-grow: 1;
}
</style>
